import simulatorTrainingRoutes from 'modules/simulatorTrainings/common/routing/routes'

const routes = {
  root: `${simulatorTrainingRoutes.instructorSL}/exercise/list`,
}

export default routes
